import { render, staticRenderFns } from "./commercial-purchase-comment-edit-block.vue?vue&type=template&id=38365880&"
import script from "./commercial-purchase-comment-edit-block.vue?vue&type=script&lang=js&"
export * from "./commercial-purchase-comment-edit-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38365880')) {
      api.createRecord('38365880', component.options)
    } else {
      api.reload('38365880', component.options)
    }
    module.hot.accept("./commercial-purchase-comment-edit-block.vue?vue&type=template&id=38365880&", function () {
      api.rerender('38365880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/partials/commercial-purchase-comment-edit-block.vue"
export default component.exports